import React, { useCallback, useState } from 'react';
import { useField } from 'formik';
import { useDropzone } from 'react-dropzone';
import { ValidationMessage } from '../../../Helpers/validation/validationMessage';
import { getLabel } from '../../../Language/labels';
import { useEffect } from 'react';

const MAX_FILE_SIZE = 5120000;
const MIN_FILE_SIZE = 1000000;
const MAX_FILE_NAME_LENGTH = 199;
const IMAGE_TYPES = ['image/png', 'image/jpeg'];

export const ImageUpload = ({ label, ...props }) => {
  const [, meta, helpers] = useField(props);
  const [selectedImage, setSelectedImage] = useState();
  const [firstLoad, setFirstLoad] = useState(0);
  const [showImageSizeLabel, setShowImageSizeLabel] = useState(false);
  const [imageError, setImageError] = useState('');

  useEffect(() => {
    if (!selectedImage && props.value.path && firstLoad === 0) {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        setSelectedImage(e.target.result);
      }
      fileReader.readAsDataURL(props.value);
      setFirstLoad(1);
    }
  }, [props.value, selectedImage, firstLoad])

  const onDrop = useCallback(acceptedFiles => {
    //screen out anything not jpg or png
    if (!IMAGE_TYPES.includes(acceptedFiles[0].type)) {
      setImageError(getLabel('imageDropZone'));
      setShowImageSizeLabel(true);
      return;
    }

    if (acceptedFiles[0].size >= MIN_FILE_SIZE && acceptedFiles[0].size <= MAX_FILE_SIZE && 
      acceptedFiles[0].name.length <= MAX_FILE_NAME_LENGTH) {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          setSelectedImage(e.target.result);
        }
        helpers.setValue(acceptedFiles[0]);
        fileReader.readAsDataURL(acceptedFiles[0]);
        setShowImageSizeLabel(false);
    }else{
      if (acceptedFiles[0].size < MIN_FILE_SIZE) {
        helpers.setError(getLabel('min-size'));
        setImageError(getLabel('min-size'));
      }else{
        helpers.setError(getLabel('entryThumbnailSize'));
        setImageError(getLabel('entryThumbnailSize'));
      }
      setShowImageSizeLabel(true);
    }
  }, [helpers])

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const clearImage = (e) => {
    setSelectedImage(null);
    helpers.setValue('');
    e.stopPropagation();
    e.preventDefault();
  }

  return (
    <>
      <div className='image-upload-container'>
        {!selectedImage && <div className='image-upload' {...getRootProps()}>
          <input name="thumbnail" id="thumbnail" {...getInputProps()} aria-required="true" />
          <div>
            <span className='block'><h1>{getLabel('entryImageDrop')}</h1></span>
            {showImageSizeLabel && <span className='block'><h1 className='image-size-error-message'>{imageError}</h1></span>}
          </div>
        </div>}
        {selectedImage &&
          <div className='selected-image'>
            <button onClick={clearImage}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img alt="Thumbnail" src={selectedImage}></img>
          </div>}
      </div>
      <ValidationMessage {...meta} />
    </>
  )
}